import { Mui } from "@osu/react-ui";
import RenderInputControls from "../renderInputControls";
import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useApplicantDetailsState } from "../../hooks/useApplicantDetailsState";
import { reset, setCheckableNotes } from "../../slices/administrativeNotes";

const classes = {
  // Uncomment if we ever go back to 3 columns of notes
  //   root: { display: "flex", justifyContent: 'space-between' },
  requiredSubselectionInstructions: {
    fontSize: "90%",
  },
  placeholderWidth: {
    visibility: "hidden",
  }
};

const Notes = () => {
  const { data, isFetching } = useApplicantDetailsState();
  const resumeLaterAdminNotes = data?.details.resumeLaterAdminNotes ?? [];
  const config = data?.configuration.administrativeNotes ?? {};
  // Editable for the Honors assigned reviewer OR the Scholars in-progress owner (the caller who pulled /
  // was manually assigned this applicant's IN_REVIEW queue entry). isScholarsInProgressOwner is the
  // Scholars-side parallel to isAssignedReviewer (which is Honors-Review-derived and never set for Scholars).
  const readonly = !(data?.status.isAssignedReviewer || data?.status.isScholarsInProgressOwner);
  
  const noteDispatch = useDispatch();

  // Reset reviewNotes slice data on page exit
  useEffect(() => { return () => noteDispatch(reset()); }, [])  // eslint-disable-line
  
  useEffect(() => { // In order to set it exactly once on dataload, must use useEffect
    if (isFetching) { return; }
    
    noteDispatch(setCheckableNotes({ config, resumeLaterAdminNotes }));
  }, [isFetching, noteDispatch]); // eslint-disable-line
  
  function requirementInstructionsEle(areaName) {
    return [
        <Mui.Typography key={`${areaName}-0`} sx={classes.requiredSubselectionInstructions} tabindex="0">* A subfield is required when you select {areaName}</Mui.Typography>,
        <Mui.Typography key={`${areaName}-1`} sx={{ ...classes.requiredSubselectionInstructions, ...classes.placeholderWidth }} tabindex="0">* A subfield is required when you select {areaName}</Mui.Typography>
    ];
  }
   
  return (
    <Mui.Container>
        <Mui.Box sx={classes.root}>
            <Mui.FormControl component="fieldset">
                <RenderInputControls section="DOCUMENT" requirementInstructionsEle={requirementInstructionsEle("other document")} allPossibleNotes={config} readonly={readonly}  />
            </Mui.FormControl>
            <Mui.FormControl component="fieldset">
                <RenderInputControls section="OTHERSCONCERNS" allPossibleNotes={config} readonly={readonly}  />
            </Mui.FormControl>
        </Mui.Box>
    </Mui.Container>
  );
};

export default Notes;